import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import {
  monthOptions,
  yearOptions,
} from "../../../dashboardLevelMekanikSA/dasboardLaporanHarianPartByMekanikdanSA/config";
import Api from "../../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import { HttpStatus } from "../../../../../common/Constants";
import SimpleMultiHeaderTable from "../../../../../../modules/SimpleMultiHeaderTable";
import {
  buildExcelRequestBodyPendapatan,
  generateGroupHeaders,
  generateTableColumns,
  getDaysInMonth,
} from "./config";
import { saveAs } from "file-saver";
export default class LaporanPendapatan extends Component {
  constructor(props) {
    super(props);
    this.currentMonth = Number(moment().format("MM"));
    this.currentYear = Number(moment().format("YYYY"));

    this.state = {
      month: monthOptions.find((item) => item.value === this.currentMonth),
      year: yearOptions.find((item) => item.value === this.currentYear),
      dataTable: [],
      rawData: null,
    };
  }

  componentDidMount() {}

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  constructData = (apiData) => {
    const { month, year } = this.state;
    const days = getDaysInMonth(year.value, month.value - 1);

    return days.map((day, index) => {
      const row = { tanggal: day };
      const dayIndex = index + 1;

      apiData.forEach((item) => {
        const key = item.serviceCategory;

        row[`${key}_daily`] = item.daily?.[dayIndex] ?? 0;
        row[`${key}_acc`] = item.accumulation?.[dayIndex] ?? 0;
      });

      return row;
    });
  };

  fetchData = async () => {
    const { onTriggerLoading, search } = this.props;
    const { month, year } = this.state;

    if (!search) return;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPendapatanJobHarian,
      menuName: "Dashboard Kabeng Keatas - Laporan Pendapatan Job Harian",
      args: {
        kodeCabang: this.props.search,
        year: year?.value,
        month: month?.value,
      },
    });

    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const services = res.data.data;

      this.setState({
        dataTable: this.constructData(services),
        columns: generateTableColumns(services),
        groupHeaders: generateGroupHeaders(services),
        rawData: res.data.data,
      });
    }
  };

  handleSearch = () => {
    this.fetchData();
  };

  handlePrint = async () => {
    const { month, year, dataTable, rawData } = this.state;
    const { onTriggerLoading, setError } = this.props;

    onTriggerLoading();

    try {
      const reqBody = buildExcelRequestBodyPendapatan({
        year: year.value,
        dataTable,
        rawData,
      });

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateAdvancedExcelFromPayload,
        menuName: "Dashboard Level Kabeng Keatas - Laporan Pendapatan Job",
        setError,
        args: reqBody,
      });

      if (!res?.ok) {
        throw new Error("Response tidak valid");
      }

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, `${reqBody.filename}.xlsx`);
    } catch (error) {
      console.error("Error saat generate Excel:", error);
      if (setError) {
        setError("Gagal generate file Excel");
      }
    } finally {
      onTriggerLoading();
    }
  };

  render() {
    const { month, year, dataTable } = this.state;
    return (
      <React.Fragment>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        {this.state.dataTable.length > 0 && (
          <div style={{ marginBottom: 30 }}>
            <SimpleMultiHeaderTable
              data={dataTable}
              columns={this.state.columns}
              groupHeaders={this.state.groupHeaders}
            />
          </div>
        )}

        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton text="CETAK" onClick={this.handlePrint} />
        </FlexView>
      </React.Fragment>
    );
  }
}
